define('commons/popup-dialog',['jquery', 'commons/message-manager', 'jquery.ui'], function($, messages) {

    var PopupDialog = function(container, options) {
        // Setting the configuration
        this.settings = $.extend({
            popupLinks: '.popupLink',
            popupTitle: '',
            resizable: false,
            draggable: true,
            modal: false,
            closeOnEscape: true,
            width: '50%',
            height: 300,
            onSuccess: function(data) {
            },
            reload: -1,
            buttons: [],
            displayClose: true,
            format: 'html',
            popupContentSelector: null,
            onDataLoaded: null,
            clearBeforeLoad: true,
            onBeforeOpen: function() {
                return true;
            },
            classes: "popup-dialog"
        }, options);
        this.container = $(container);
        // Create popup
        var popupContent;
        if (this.settings.popupContentSelector !== null) {
            popupContent = $(this.settings.popupContentSelector);
        } else {
            popupContent = $('<div></div>').appendTo(this.container);
        }
        this.popup = popupContent.dialog({
            'autoOpen': false,
            'resizable': this.settings.resizable,
            'draggable': this.settings.draggable,
            'height': this.settings.height,
            'width': this.settings.width,
            'modal': this.settings.modal,
            'zIndex': 100,
            'title': this.settings.popupTitle,
            'buttons': this.settings.buttons,
            'dialogClass': this.settings.classes,
            'closeOnEscape': this.settings.closeOnEscape,
            'open': $.proxy(function(event, ui) {
                if (!this.settings.displayClose) {
                    // Hide close button
                    $(event.target).parent().children().children('.ui-dialog-titlebar-close').hide();
                }
            }, this)
        });
        this.popupContent = this.popup.dialog('widget').find('.ui-dialog-content');
        this.popupTitle = this.popup.dialog('widget').find('.ui-dialog-title');

        this.popup.on('dialogclose', $.proxy(function(event, ui) {
            clearTimeout(this.timeout);
        }, this));
        // Catches the show popup click events
        this.bind();
    };

    PopupDialog.prototype.showPopup = function(event) {
        if (!this.settings.onBeforeOpen()) {
            return false;
        }

        if (this.popup.dialog('isOpen')) {
            this.popup.dialog('close');
        }
        // Close timeout
        clearTimeout(this.timeout);
        this.popupContent.addClass('loading');
        this.popup.dialog('option', 'title', event.data.title);
        this.popup.dialog('open');
        $('button.ui-dialog-titlebar-close').focusout();
        this.loadDataPopup(event.data.url);
        return false;
    };

    PopupDialog.prototype.setContent = function(data) {
        this.popupContent.removeClass('loading');
        switch (this.settings.format) {
            case 'json':
                if (this.settings.onDataLoaded !== null){
                    this.settings.onDataLoaded(data);
                } else {
                    messages.error('An error has occurred with the popup content.');
                }
                break;
            default:
                // HTML By default
                this.popupContent.html(data);
                break;
        }
        this.settings.onSuccess(data);
    };

    PopupDialog.prototype.loadDataPopup = function(url) {
        if (this.settings.clearBeforeLoad) {
            this.popupContent.html('');
        }
        $.ajax({
            type: 'GET',
            url: url,
            dataType: this.settings.format,
            success: function(data) {
                this.setContent(data);
                if (this.settings.reload > 0) {
                    this.timeout = setTimeout($.proxy(function() {
                        if (this.popup.dialog('isOpen')) {
                            this.loadDataPopup(url);
                        }
                    }, this), this.settings.reload * 1000);
                }
            },
            context: this
        });
        return false;
    };

    PopupDialog.prototype.unbind = function() {
        // Clean the action links
        this.container.find(this.settings.popupLinks).each(function(index, link) {
            $(link).unbind();
        });
    };

    PopupDialog.prototype.bind = function() {
        var here = this;
        // Clean the action links
        this.container.find(this.settings.popupLinks).each(function(index, link) {
            var $link = $(link);
            var href = $.trim($link.attr('href'));
            var title = here.settings.popupTitle !== '' ? here.settings.popupTitle : $link.attr('title');
            if (href.search(/^#.*/) != -1 || href.search(/^javascript:.*/) != -1) {
                $link.click(function(event) {
                    here.onLinkClick(this);
                    return false;
                });
            } else {
                $link.click({
                    url: href,
                    title: title
                }, $.proxy(here.showPopup, here));
            }
        });
    };

    return PopupDialog;
});

